import { useLayoutEffect, useState } from "react"
import { createThrottledFunction } from "shared/utils/createThrottledFunction"

const useGetViewportSize = () => {
  const [viewportWidth, setViewportWidth] = useState<number>(0)
  const [viewportHeight, setViewportHeight] = useState<number>(0)
  const resizeFunction = createThrottledFunction(() => {
    setViewportWidth(document.documentElement.clientWidth)
    setViewportHeight(document.documentElement.clientHeight)
  }, 200)

  useLayoutEffect(() => {
    window.addEventListener("resize", resizeFunction)
    resizeFunction()
    return () => {
      window.removeEventListener("resize", resizeFunction)
    }
  }, [])

  return { viewportWidth, viewportHeight }
}

export default useGetViewportSize
